import API from './API'
import Record_behavir from './FirebaseAPI/RecordBill'
import Cookies from 'js-cookie'

var record = new Record_behavir()
const Store = (function () {
  function store() {}
  store.prototype.createStoreApp = async function (payload) {
    return await API.post(`cooperative_store/add/app`, payload)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '新增商家APP'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = payload.storeId
        recordInfo.note = payload
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.result,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err.data.result,
        }
      })
  }
  store.prototype.removeStorePhone = async function (payload) {
    return await API.put(`cooperative_store/remove/phone`, payload)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '移除商家電話'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = payload.id
        recordInfo.note = payload
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.result,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  store.prototype.addStorePhone = async function (payload) {
    return await API.put(`cooperative_store/add/phone`, payload)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '新增商家電話'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = payload.id
        recordInfo.note = payload
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.result,
          storeId: res.storeId,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  store.prototype.getStoreDetail = function (id) {
    return API.get(`storeDetail/?id=${id}`)
  }
  store.prototype.getStoreList = function (npp, page) {
    return API.get(`storelist/?npp=${npp}&page=${page}`)
  }
  store.prototype.createStore = function (store) {
    return API.post(`cooperative_store/addstoreinfo`, store)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '新增商家資料'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = res.storeId
        recordInfo.note = ''
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: {
            storeId: res.storeId,
            result: res.result,
          },
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err.data.result,
        }
      })
  }
  store.prototype.deleteStore = async function (id) {
    return await API.delete(`cooperative_store/removestore/?id=${id}`)
      .then((res) => {
        if (!res.success) throw new RangeError(res.message)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '移除商家資料'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = id
        recordInfo.note = ''
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.message,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  store.prototype.updateStoreInfo = async function (store) {
    return await API.put(`cooperative_store/store_info/update`, store)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '更新商家資料'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = store.id
        recordInfo.note = store
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.result,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  store.prototype.updateStoreAppInfo = async function (store) {
    return await API.put(`cooperative_store/store_app/update`, store)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '更新商家App資料'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = store.id
        recordInfo.note = store
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.result,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  store.prototype.updateStorePwd = async function (id, position, payload) {
    return await API.put(
      `cooperative_store/pw/?id=${id}&position=${position}`,
      payload,
    )
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '更新商家密碼'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = id
        recordInfo.note = ''
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.result,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  store.prototype.updateService = async function (id, service) {
    return await API.post(`cooperative_store/service/${id}`, { service })
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '更新商家顯示服務'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = id
        recordInfo.note = ''
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.message,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  store.prototype.addArrivalTime = async function (id, payload) {
    return await API.post(`cooperative_store/arrival_time/${id}`, payload)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '新增商家時間範圍'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = id
        recordInfo.note = ''
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.message,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err.data.error,
        }
      })
  }
  store.prototype.deleteArrivalTime = async (id, storeId, note) => {
    return await API.delete(`cooperative_store/arrival_time/${id}`)
      .then((res) => {
        if (!res.success) throw new RangeError(res)
        let recordInfo = {}
        recordInfo.type = '商家'
        recordInfo.event = '刪除商家時間範圍'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = storeId
        recordInfo.note = note
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.message,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err.data.error.message,
        }
      })
  }
  return store
})()
export default Store



// WEBPACK FOOTER //
// ./src/assets/js/libs/Store.js